export default __webpack_public_path__ + "static/logo-35c3c222a8ca30c4b4b40af5489a1031.svg";